import {Feature, SelectedFeature} from "../js/product";
import {ProduktAuswahlFeaturedObject} from "../../konfi_mobile/src/store/ProduktAuswahlStore"

export function createSelectedFeature(featuredObject:ProduktAuswahlFeaturedObject, feature:Feature|null) {
    return new SelectedFeature(
        featuredObject.FeaturedObject,
        feature!==null ? feature.Feature : featuredObject.StandardFeature,
        feature!==null ? feature.Name : featuredObject.standardFeatureInt,
        feature!==null ? feature.Kuerzel : featuredObject.standardFeatureAbkuerzung,
        feature!==null ? feature.einzublendendeDreiDParts : [],
        feature!==null ? feature.imKonfiBeiDerProduktuebersichtAuswaehlbar : "0",
        feature!==null ? feature.imKonfiVerstecktesAberFuerPreisberechnungRelevantesFeature : "0",
        featuredObject.zeigeZugehoerigeFeatureBeiFeatureAuswahlAn
    );
}
